import React, { ReactElement, createContext, useContext } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../components";
import StackdriverErrorReporter from "stackdriver-errors-js";
import { version } from "../../package.json";
import { ViEnvVariableNotSetError } from "../models/Errors";

const key = process.env.REACT_APP_STACKDRIVER_KEY;
const projectId = process.env.REACT_APP_GCP_PROJECT_ID;
const service = process.env.REACT_APP_ORIGIN_SYSTEM;
const active = process.env.REACT_APP_STACKDRIVER_ACTIVE?.toLowerCase() === "true";

const ErrorHandler = (() => {
  let StackdriverErrorHandler: any = null;
  if (active) {
    if (!key) throw new ViEnvVariableNotSetError("REACT_APP_STACKDRIVER_KEY");
    if (!projectId) throw new ViEnvVariableNotSetError("REACT_APP_GCP_PROJECT_ID");
  }

  if (key && projectId) {
    StackdriverErrorHandler = new StackdriverErrorReporter();
    StackdriverErrorHandler.start({
      key,
      projectId,
      service,
      version,
      disabled: !active,
    });
  }

  return {
    setUser: function (user: string) {
      if (StackdriverErrorHandler) StackdriverErrorHandler.setUser(user);
    },
    report: function (e: Error) {
      StackdriverErrorHandler?.report(e);
    },
  };
})();

const ErrorContext = createContext(ErrorHandler);

export const ErrorProvider = ({ children }: { children: ReactElement }) => {
  return (
    <ErrorContext.Provider value={ErrorHandler}>
      <ErrorBoundary FallbackComponent={ErrorFallback} onError={ErrorHandler.report}>
        {children}
      </ErrorBoundary>
    </ErrorContext.Provider>
  );
};

export const useErrorContext = () => useContext(ErrorContext);
